import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconMoney20(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            className={customClassName}
            name="IconMoney20"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M9.75 1.917a.75.75 0 0 1 .75.75v1.105c1.043.096 1.798.482 2.312.892.291.233.498.469.635.651a3 3 0 0 1 .215.332l.005.01.002.004v.002h.001L13 6l.67-.336a.75.75 0 0 1-1.336.68l-.011-.019a1 1 0 0 0-.075-.11 2 2 0 0 0-.373-.38c-.346-.276-.933-.585-1.875-.585-1.052 0-1.748.198-2.163.489-.37.26-.587.643-.587 1.261 0 .512.233.866.728 1.196.537.358 1.283.615 2.156.904l.105.035c.795.262 1.696.56 2.398 1.004.772.49 1.41 1.228 1.41 2.361 0 1.243-.55 2.204-1.346 2.837a4.34 4.34 0 0 1-2.201.885v1.111a.75.75 0 0 1-1.5 0v-1.195c-.893-.197-1.67-.624-2.245-1.02a8.7 8.7 0 0 1-1.207-1.006l-.073-.075-.02-.022-.007-.007-.002-.002v-.001h-.001L6 13.5l-.556.504a.75.75 0 0 1 1.11-1.009h.001v.001h.001l.01.012.05.052c.047.046.117.116.209.2.184.17.452.396.78.622.672.462 1.521.868 2.395.868.633 0 1.287-.205 1.768-.587.462-.367.78-.906.78-1.663 0-.451-.212-.776-.714-1.094-.542-.343-1.29-.59-2.17-.882H9.66c-.825-.274-1.778-.589-2.515-1.08C6.366 8.925 5.75 8.154 5.75 7c0-1.048.409-1.916 1.226-2.489.55-.386 1.24-.607 2.024-.704v-1.14a.75.75 0 0 1 .75-.75"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconMoney20);
